import React from 'react';
import ValidationStatusBadge from '../common/ValidationStatusBadge';
import { IValidationErrorByExtraction } from '../../types/validation-types';

interface CellContentProps {
  extractionId: string;
  showRowValidationBadge: boolean;
  validationResponse: IValidationErrorByExtraction | undefined;
  validating?: boolean;
  validationNotReady?: boolean;
  field: string;
  value: string | number | undefined;
}

const CellContent: React.FC<CellContentProps> = ({
  extractionId,
  showRowValidationBadge,
  validationResponse,
  validating = false,
  validationNotReady = false,
  field,
  value,
}) => {
  return (
    <>
      {showRowValidationBadge ? (
        <ValidationStatusBadge
          extractionId={extractionId}
          validationResponse={validationResponse}
          isValidating={validating}
          isNotReady={validationNotReady}
          cypressId={`grid-${field}`}
        />
      ) : null}
      {value || ''}
    </>
  );
};

export default CellContent;
